import { http } from '@/http'

export default {
  // El header X-City-Id lo agrega el interceptor global (DEF-ADM-009).
  getFleet() {
    return http.get('/api/v1/tracking/fleet')
  },
  // Cierra el turno de un vehículo desde el admin (end_type=FORZADO).
  forceCloseShift(shiftId) {
    return http.post(`/api/v1/shifts/${shiftId}/force-close`)
  }
}
